var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "py-1" }, [
    !_vm.isLeafNode
      ? _c(
          "div",
          { staticClass: "is-flex is-align-items-center" },
          [
            _c(
              "a",
              { staticClass: "u-clickable", on: { click: _vm.clickLink } },
              [
                _c("span", { staticClass: "icon" }, [
                  _vm.isActive
                    ? _c("i", { staticClass: "fas fa-caret-down" })
                    : _c("i", { staticClass: "fas fa-caret-right" }),
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.item.label))]),
              ]
            ),
            _vm._v(" "),
            _c("DrillStartModal", {
              attrs: { "category-slug": _vm.item.slug },
            }),
          ],
          1
        )
      : _c("div", [
          _c(
            "div",
            { staticClass: "is-flex is-align-items-center" },
            [
              _c(
                "a",
                {
                  staticClass: "u-clickable",
                  on: {
                    click: function ($event) {
                      _vm.isActivePosts = !_vm.isActivePosts
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _vm.isActivePosts
                      ? _c("i", { staticClass: "fas fa-caret-down" })
                      : _c("i", { staticClass: "fas fa-caret-right" }),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.item.label))]),
                ]
              ),
              _vm._v(" "),
              _c("DrillStartModal", {
                attrs: { "category-slug": _vm.item.slug },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _vm.isActivePosts
                ? _c("DrillPostList", {
                    attrs: { "category-slug": _vm.item.slug },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }